import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import AuditLogDetails, { useDeleteAuditLogActionButton } from '../../../../shared/AuditLogDetails';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';

export type ProfileActivityDetailsScreenOwnProps = {};

export type ProfileActivityDetailsScreenProps = ProfileActivityDetailsScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'profile-activity-details'>;
};

const ProfileActivityDetailsScreen: React.FC<ProfileActivityDetailsScreenProps> = ({ route }) => {
    const goBack = useGoBack();
    const { deleteAuditLogAction } = useDeleteAuditLogActionButton({
        auditLogId: route.params.auditLogId,
        medicalProfileFileId: route.params.profileId,
        onDeleted: goBack,
    });
    return (
        <ProfileHeaderContainer profileId={route.params.profileId} bottomBorder omitChatButton>
            <ActionButtonLayout scrollable actions={[deleteAuditLogAction]}>
                <AuditLogDetails auditLogId={route.params.auditLogId} profileId={route.params.profileId} />
            </ActionButtonLayout>
        </ProfileHeaderContainer>
    );
};

export default React.memo(ProfileActivityDetailsScreen);
